import type {IconProp} from "@fortawesome/fontawesome-svg-core";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import type {FunctionComponent, ReactNode} from "react";
import React from "react";
import {NavLink} from "react-router";
import {DropdownItem} from "reactstrap";

export interface IMenuItem {
  icon: IconProp;
  to: string;
  id?: string;
  onClick?: React.MouseEventHandler;
  "data-cy"?: string;
  children: ReactNode;
}

export const MenuItem: FunctionComponent<IMenuItem> = (props) => {
  const {to, icon, id, children, onClick} = props;

  return (
    <DropdownItem tag={NavLink} to={to} id={id} onClick={onClick} data-cy={props["data-cy"]}>
      <FontAwesomeIcon icon={icon} fixedWidth /> {children}
    </DropdownItem>
  );
};
